var meeting_filters = ( function( $ ) {

	var $meeting_filters = false;
	var $form = false;
	var $fields = false;

	var _init = function() {
		$meeting_filters = $( '#meeting-filters' );
		$form = $meeting_filters.find( 'form' );
		$fields = $form.find( 'input' );

		$fields.on( 'change', _field_change );
	};

	var _field_change = function( event ) {
		var $past_events = $( 'input[name="past_events"]' );

		if ( $past_events.is( ':checked' ) ) {
			if ( $( this ).attr( 'name' ) === 'past_events' ) {
				$( 'input[name="meeting_type"]:checked' ).prop( 'checked', false );
			} else {
				$past_events.prop( 'checked', false );
			}
		}

		submit();
	};

	var submit = function() {
		var base_url = $meeting_filters.data( 'base-url' );

		window.location = base_url + _generate_search_str();
	};

	var _generate_search_str = function() {
		var query = {};
		var form_data = $( '#filters-form' ).serializeArray();

		$.each( form_data, function( index, value ) {
			if ( query[ value.name ] ) {
				query[ value.name ] += ',' + value.value;
			} else {
				query[ value.name ] = value.value;
			}
		} );

		return decodeURIComponent( URI( '' ).query( query ).toString() );
	};

	$( document ).ready( _init );

	return {
		submit : submit
	};

} ) ( jQuery );

module.exports = meeting_filters;